
    import {defineComponent, computed, reactive} from "vue";
    import store from '../store/index'

    export default defineComponent({
        name: "score",
        setup() {
            const state = reactive({
                store: computed(() => store.state),
            })
            return {
                store: state.store
            }
        }
    })
